import Rest from '@/services/Rest';

export default class MemberMetaService extends Rest {
  static resource = 'member/meta';
}
